import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Grid } from "@/comn/components";
import { comnUtils } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button } from "@/comn/components"; // 화면 구성 컴포넌트
import { useForm, useFetch, useResource, useGrid, useAuth, useModal, useStore, useToast, usePage } from "@/comn/hooks"; // hook
import { URLS, APIS, SG_DDLN_XTNS_LIST, SF_DDLN_XTNS_LIST_SRCH } from "./services/OsciBllService"; // 서비스

/*
 * Deadline Extension List
 * !== 데드라인 연장 목록 ==!
 */
export const OSCI0401004Q = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */

    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "OSC0020" }, { area: "coCd" }, { area: "comnCd", comnCd: "OSC0096" }],
    });

    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003", "auth_osci0021"],
    }); // Page Unique identifier !== 화면 고유 식별자 ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Deadline Extension Search !== 데드라인 연장 검색 ==!
        ddlnXtnsSrch: useForm({
            defaultSchema: SF_DDLN_XTNS_LIST_SRCH,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Deadline Extension List !== 데드라인 연장 목록 ==!
        ddlnXtnsList: useGrid({
            defaultSchema: SG_DDLN_XTNS_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get Deadline Extension List !== 데드라인 연장 목록 조회 ==!
        getDdlnXtnsList: useFetch({
            api: (page = grid.ddlnXtnsList.page) => {
                let data = {
                    ...form.ddlnXtnsSrch.getValues(),
                    orgCd: auth.get("orgCd"),
                };

                if (data.bllNo) {
                    data.bllNo = data.bllNo.trim(); // 앞뒤 공백 제거
                    // Bill No.가 "X-XXXX-XX-XXXXXXX-X"(bllMgmtId 마스크) 패턴이면 '-' 제거 후 조회
                    if (/^[A-Za-z0-9]-[A-Za-z0-9]{4}-[A-Za-z0-9]{2}-[A-Za-z0-9]{7}-[A-Za-z0-9]$/.test(data.bllNo)) {
                        data.bllNo = data.bllNo.replaceAll("-", "");
                    }
                }

                return APIS.getDdlnXtnsList(data, page, grid.ddlnXtnsList.size);
            },
            enabled: comnUtils.isEmpty(form.ddlnXtnsSrch.errors) && form.ddlnXtnsSrch.isSubmitted,
            key: [grid.ddlnXtnsList.page, grid.ddlnXtnsList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.ddlnXtnsSrch.getValues(),
                    page: grid.ddlnXtnsList.page,
                    size: grid.ddlnXtnsList.size,
                });
            },
            onError: () => {},
            showToast: true,
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Get Deadline Extension List !== 데드라인 연장 목록 조회 ==!
        getDdlnXtnsList: (page: number = 0) => {
            form.ddlnXtnsSrch.handleSubmit(
                (data) => {
                    // Validation Check !== 밸리데이션 체크 ==!
                    grid.ddlnXtnsList.setPage(page);
                    fetch.getDdlnXtnsList.fetch(page);
                },
                (data) => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },
    };

    const render = {
        grid_ddlnXtnsList: {
            head: {},
            cell: {
                bllNo: (props: any) => {
                    const { binding, rowValues, value } = props;
                    return (
                        <Layout direction="col" gap={1}>
                            <span style={{ color: "blue" }} title={`${rowValues.bllNo}:${rowValues.ddlnXtnsDgr}`}>
                                <Link
                                    to={`${URLS.osci0401005q}/${rowValues.bllTpCd}-${rowValues.bllSysmCd}-${rowValues.bllYy}-${rowValues.bllSrno}-${rowValues.bllDgr}`}
                                >{`${rowValues.bllNo}`}</Link>
                            </span>
                        </Layout>
                    );
                },
            },
            edit: {},
            checkbox: (row: any) => {
                let checkFlag = true;
                if (row.aprvStatCd === "C" || row.useYn === "D" || row.useYn === "G" || row.useYn === "I") {
                    checkFlag = false;
                }

                return checkFlag;
            },
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        handler.getDdlnXtnsList(pgeStore?.page);
    }, []);

    return (
        <Page>
            <form>
                <Group>
                    <Group.Body>
                        <Layout direction="row">
                            <Layout.Left size={6}>{}</Layout.Left>
                            <Layout.Right>{}</Layout.Right>
                        </Layout>
                        <Group.Section>
                            <Group.Row>
                                {/* Bill Number !== 고지서 번호 ==!  */}
                                <Group.Control {...form.ddlnXtnsSrch.schema.bllNo}></Group.Control>
                                <Group.Control {...form.ddlnXtnsSrch.schema.bllMgmtId}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                {/* Deadline Extension Registration Date !== 데드라인 연장 등록 일자 ==!  */}
                                <Group.Control {...form.ddlnXtnsSrch.schema.xtnsRgsrDtmRnge}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                {/* Payer Menagement Number !== 납부자 관리 번호 ==!  */}
                                <Group.Control {...form.ddlnXtnsSrch.schema.pyerMgmtNo}></Group.Control>
                                {/* Approval State Code !== 승인 상태 코드 ==!  */}
                                <Group.Control {...form.ddlnXtnsSrch.schema.ddlnXtnsStatCd}></Group.Control>
                            </Group.Row>
                        </Group.Section>

                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    role="reset"
                                    onClick={() => {
                                        form.ddlnXtnsSrch.reset();
                                    }}
                                ></Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    role="search"
                                    onClick={() => {
                                        handler.getDdlnXtnsList();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
            </form>

            <Group>
                <Group.Body>
                    <Grid
                        {...grid.ddlnXtnsList.grid}
                        data={fetch.getDdlnXtnsList.data?.ddlnXtnsList}
                        render={render.grid_ddlnXtnsList}
                    />
                </Group.Body>
            </Group>
            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="new"
                        onClick={() => {
                            navigate(`${URLS.osci0401006s}/new`);
                        }}
                    ></Button>
                </Layout.Left>
            </Layout>
        </Page>
    );
};
